export default __webpack_public_path__ + "static/media/81_mobile.ea3d156e.jpg";